import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const messenger: Platform = {
  id: 'messenger',
  name: 'Messenger',
  iconIndex: PlatformRegistry.messenger.index,
  color: PlatformRegistry.messenger.color,
  buildUrl: (content: ShareContent): string => {
    // Note: fb-messenger:// protocol for mobile, web fallback
    return buildShareUrl('https://www.facebook.com/dialog/send', {
      link: content.url,
      app_id: '998115753539479', // Default app ID, should be configurable
      redirect_uri: content.url,
    });
  },
};

